import {
  DebouncedTextInput,
  Group,
  GroupItem,
  GroupTitle,
  Toolbar,
  useFieldLabel,
} from "ra-friendsofbabba";
import { SimpleForm, required, useTranslate } from "react-admin";

import { CollaborationTypeInput } from "../component/input";
import ProjectStatusInput from "./inputs/ProjectStatusInput";
import React from "react";

const Form = ({ classes, ...props }) => {
  const translate = useTranslate();
  const fieldLabel = useFieldLabel(props);
  return (
    <SimpleForm
      {...props}
      toolbar={
        <Toolbar
          backTab={3}
          backReference="technical-reports"
          backReferenceTarget="technical_report_id"
        />
      }
    >
      <Group wrapper>
        <GroupTitle
          title={translate("resources.technical-report-projects.name", {
            smart_count: 1,
          })}
        />
      </Group>
      <DebouncedTextInput
        source="name"
        maxLength={1000}
        validate={[required()]}
        multiline
        fullWidth
      />
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <CollaborationTypeInput
            source="collaboration_type_id"
            validate={required()}
          />
        </GroupItem>
      </Group>

      <DebouncedTextInput
        source="sponsor"
        maxLength={500}
        validate={[required()]}
        multiline
        fullWidth
      />
      <DebouncedTextInput
        source="partners"
        maxLength={1000}
        validate={[required()]}
        multiline
        fullWidth
      />
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <ProjectStatusInput
            source="project_status_id"
            validate={required()}
          />
        </GroupItem>
      </Group>
      <DebouncedTextInput
        source="compatibility"
        maxLength={1000}
        multiline
        fullWidth
        validate={required()}
      />
      <DebouncedTextInput
        source="notes"
        helperText={fieldLabel("notes.help")}
        maxLength={1000}
        multiline
        fullWidth
      />
    </SimpleForm>
  );
};
export default Form;
